import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { userInfo } from '@/api/mg';
export default {
  data: function data() {
    return {
      userInfo: {},
      toUserId: ''
    };
  },
  created: function created() {
    this.toUserId = this.$route.query.pid || localStorage.getItem('userId');
    this.getUserInfo({
      pid: this.toUserId
    });
  },
  methods: {
    getUserInfo: function getUserInfo(params) {
      var _this = this;
      userInfo(params).then(function (res) {
        if (res.Code === 0) {
          _this.userInfo = res.Data;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toAccount: function toAccount(userInfo) {
      this.$router.push({
        path: '/me/account',
        query: {
          userInfo: JSON.stringify(userInfo)
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    toDetail: function toDetail(name, toUserId) {
      this.$router.push({
        path: '/me/detail',
        query: {
          str: name,
          toUserId: toUserId
        }
      });
    }
  }
};